import React from 'react';
import { Box, Typography, Button, Stack, Chip } from '@mui/material';

import {
  heroContainerStyles,
  primaryButtonStyles,
  secondaryButtonStyles,
  titleStyles,
  subtitleStyles,
  ctaStyles,
  infoRowStyles,
  chipStyles,
} from '../styles/Hero.js';

import scrollToSection from '../utils/scrollToSection';

import {
  HERO_IMAGE,
  HERO_TITLE,
  HERO_SUBTITLE,
  HERO_CHIPS,
} from '../data/Hero.js';

import { prefillContactMessage } from '../utils/contactHelper.js';

const Hero = ({
  image = HERO_IMAGE,
  title = HERO_TITLE,
  subtitle = HERO_SUBTITLE,
  onGetQuote = () => {},
}) => {
  return (
    <Box
      id="hero-container"
      component="section"
      aria-label="Hero - Safinah Al Sama Shipping"
      sx={heroContainerStyles(image)}
    >
      <Box sx={{ textAlign: 'center', px: 2 }}>
        <Typography component="h1" sx={titleStyles}>
          {title}
        </Typography>

        <Typography variant="h6" component="p" sx={subtitleStyles}>
          {subtitle}
        </Typography>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={ctaStyles}
          role="group"
          aria-label="Primary calls to action"
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            aria-label="Get a Quote"
            sx={primaryButtonStyles}
            onClick={() => prefillContactMessage()}
          >
            Get a Quote
          </Button>

          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => { scrollToSection('service-container') }}
            aria-label="View Our Services"
            sx={secondaryButtonStyles}
          >
            Our Services
          </Button>
        </Stack>

        <Box sx={infoRowStyles} aria-hidden>
          {HERO_CHIPS.map((label, index) => (
            <Chip key={index} label={label} sx={chipStyles} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
